
import sliderimage from "../../../ReactKaamvalaWebsite/assets/image/sliderimage.webp";
import slidersecond from "../../../ReactKaamvalaWebsite/assets/image/sliderimage2.webp";

import slider1 from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala//hero-slider1.webp";
import slider2 from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/hero-slider2.webp";
import slider3 from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/hero-slider3.webp";
import slider4 from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/hero-slider4.webp";
import zomato from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/zomato.svg";
import zepto from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/zepto.svg";
import blinkit from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/blinkit.svg";
import uber from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/uber.svg";
import udaan from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/udaan.svg";
import hdfc from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/hdfc.svg";
import swiggy from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/swiggy.svg";
import rapido from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/rapido.svg";
import ola from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ola.svg";
import tatamotar from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/tatamotor.svg";
import urbancompany from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/urbancompany.svg";
import platform from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/platform.webp";
import kaamvala from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/choosekaamvala.svg";
import kaamvala2 from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/choosekaamvala2.svg";
import kaamvala3 from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/choosekaamvala3.svg";
import kaamvala4 from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/choosekaamvala4.svg";
import realjob from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/realjob.svg";
import realTalent from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/realtalent.svg";
import mangeture from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/man-gesture2.png";
import facebook from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ic-facebook.svg";
import linkedIn from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ic-linked-in.svg";
import twitter from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ic-twitter.svg";
import youtube from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ic-skype_footer.svg";
import instagram from "../../../ReactKaamvalaWebsite/assets/wordPressKaamwala/ic-instagram.svg";
import joblogo from "../../../ReactKaamvalaWebsite/assets/icon/job-logo.svg";
import prev from "../../../ReactKaamvalaWebsite/assets/icon/prev-icon.svg";
import next from "../../../ReactKaamvalaWebsite/assets/icon/next-icon.svg";

export const slides = [
    {
        title: "Employers: Streamline Your Hiring Process with Our App!",
        description:
            "Find and attract top talent effortlessly with our intuitive platform. Post jobs, review applications, and connect with candidates who fit your needs—all in one place.",
        buttonText: "Explore Now",
        image: slidersecond,
        alt: "Employer hiring platform",
    },
    {
        title: "Job Seekers: Discover job opportunities with Our App!",
        description:
            "Discover job opportunities that align with your skills and aspirations. Our user-friendly app empowers you to take charge of your job search and connect with employers who value your talent.",
        buttonText: "Explore Now",
        image: sliderimage,
        alt: "Job seeker platform",
    },
];
export const testimonials = [
    {
        id: 1,
        text: "Kaamvala has been instrumental in meeting our hiring needs with a professional approach. Looking forward to continued support.",
        name: "Aman Kumar",
        role: "BPO",
    },
    {
        id: 2,
        text: "Kaamvala has consistently met our hiring requirements with professionalism. We appreciate their support and look forward to more collaboration.",
        name: "Shiyam Yadav",
        role: "HDFC Bank",
    },
    {
        id: 3,
        text: "Kaamvala has greatly contributed to our hiring success. Their professional approach is impressive. Excited for ongoing partnership.",
        name: "Raunak Srivastav",
        role: "Telecaller",
    },
    {
        id: 4,
        text: "Kaamvala helped me find the perfect job in no time! The process was simple, and I started working within days of applying. Highly recommend to all job seekers.",
        name: "Rajesh Kumar",
        role: "Electrician",
    },
    {
        id: 5,
        text: "As a small business owner, I struggled to find reliable workers. Kaamvala made it so easy to post jobs and connect with qualified candidates. I hired within 48 hours!",
        name: "Neha Gupta",
        role: "Construction Contractor",
    },
    {
        id: 6,
        text: "Thanks to Kaamvala, I quickly filled several key positions at my company. The platform is easy to use, and I appreciated how efficiently I could manage applications",
        name: "Amit Singh",
        role: "Factory Manager",
    },
    {
        id: 7,
        text: "Kaamvala connected me with the right job that matched my skills perfectly. I found work close to home and couldn't be happier with the platform's simplicity.",
        name: "Pooja Sharma",
        role: "Delivery Driver",
    },
];

export const jobCards = [
    {
        id: 1,
        title: "Software Developer",
        company: "Advancing Packaging Private Limited",
        posted: "Posted 1 Day Ago",
        experience: "1-2 Years",
        salary: "1200k - 15000k",
        location: "Noida",
        workMode: "Full Time",
        hybrid: "Hybrid",
        shift: "Day",
        description:
            "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
    },
    {
        id: 2,
        title: "Software Developer",
        company: "Advancing Packaging Private Limited",
        posted: "Posted 1 Day Ago",
        experience: "1-2 Years",
        salary: "1200k - 15000k",
        location: "Noida",
        workMode: "Full Time",
        hybrid: "Hybrid",
        shift: "Day",
        description:
            "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
    },
    {
        id: 3,
        title: "Software Developer",
        company: "Advancing Packaging Private Limited",
        posted: "Posted 1 Day Ago",
        experience: "1-2 Years",
        salary: "1200k - 15000k",
        location: "Noida",
        workMode: "Full Time",
        hybrid: "Hybrid",
        shift: "Day",
        description:
            "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
    },
    {
        id: 4,
        title: "Software Developer",
        company: "Advancing Packaging Private Limited",
        posted: "Posted 1 Day Ago",
        experience: "1-2 Years",
        salary: "1200k - 15000k",
        location: "Noida",
        workMode: "Full Time",
        hybrid: "Hybrid",
        shift: "Day",
        description:
            "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
    },
    {
        id: 5,
        title: "Software Developer",
        company: "Advancing Packaging Private Limited",
        posted: "Posted 1 Day Ago",
        experience: "1-2 Years",
        salary: "1200k - 15000k",
        location: "Noida",
        workMode: "Full Time",
        hybrid: "Hybrid",
        shift: "Day",
        description:
            "As an intern at Advancing Packaging, you will have the opportunity to work closely with our team to develop and execute strategic initiatives that drive growth and success for our company. You will also have the chance to utilize your skills in Content Marketing and Articulate Storylines to create engaging and impactful marketing materials for our clients.",
    },
];

export const images = {
    slider1,
    slider2,
    slider3,
    slider4,
    zomato,
    zepto,
    blinkit,
    uber,
    udaan,
    hdfc,
    swiggy,
    rapido,
    ola,
    tatamotar,
    urbancompany,
    platform,
    kaamvala,
    kaamvala2,
    kaamvala3,
    kaamvala4,
    realjob,
    realTalent,
    mangeture,
    facebook,
    linkedIn,
    twitter,
    youtube,
    instagram,
    joblogo,
    prev,
    next,
}